import angular from 'angular';
import ngCookies from 'angular-cookies';
import constants from 'app/constants';
import {
  reportsDataService,
  ssDialogService,
  loaderService
} from 'app/services';
import {
  alerts
} from 'app/components/global';

import controller from './bulk-delete-report-instances-dialog.controller';
import template from './bulk-delete-report-instances-dialog.html';

import bulkDeleteReportInstance from './bulkDeleteReportInstance';
import bulkDeleteReportInstancesConfirmDialog from '../dialog.bulkDeleteReportInstancesConfirmDialog';

class dialogService {
  getOptions($event, { reportType, reportInstances }) {
    return {
      controller,
      controllerAs: 'bulkDeleteReportInstancesDialogVM',
      locals: {
        reportType,
        reportInstances,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.reports.myReports.reportType.bulkDeleteReportInstancesDialog', [
  ngCookies,
  constants,
  reportsDataService,
  ssDialogService,
  alerts,
  loaderService,
  bulkDeleteReportInstance,
  bulkDeleteReportInstancesConfirmDialog,
])
  .service('bulkDeleteReportInstancesDialog', dialogService)
  .name;
